/**
 * produces lines of sql consistent with the formatter
 * e.g. sqlClause("group by", ["1", "2", "3"]) produces
 * [
 *   "group by 1,",
 *   "         2,",
 *   "         3",
 * ]
 */
export function sqlClause(keyword: string, args: string[]): string[] {
  const spacing = " ".repeat(keyword.length);
  return args.map((arg, idx) => {
    const maybeComma = idx === args.length - 1 ? "" : ",";
    return `${idx === 0 ? keyword : spacing} ${arg}${maybeComma}`;
  });
}

// lines is expected to be non-empty
export function wrap(
  lines: string[],
  { prefix, suffix }: { prefix: string; suffix: string },
): string[] {
  if (lines.length === 1) {
    const [line] = lines;
    return [`${prefix}${line}${suffix}`];
  } else {
    const [first, ...rest] = lines;
    rest[rest.length - 1] += suffix;
    const indent = " ".repeat(prefix.length);
    return [prefix + first, ...rest.map((line) => indent + line)];
  }
}
